
<template>
    <span :class="priceClass">${{ formattedPrice }}</span>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3'; // If using Inertia

const props = defineProps({
    initialPrice: {
        type: Number,
        required: true,
    },
    mint: {
        type: String,
        required: true,
    }
});

const currentPrice = ref(props.initialPrice);
const previousPrice = ref(props.initialPrice);
let intervalId = null;

const formattedPrice = computed(() => {
    // Basic formatting, reuse roundPrice logic if possible
    if (currentPrice.value === 0) return '0.00';
    if (currentPrice.value > 1) return currentPrice.value.toFixed(2);
    if (currentPrice.value > 0.01) return currentPrice.value.toFixed(4);
    return currentPrice.value.toPrecision(3); // For very small numbers
});

const priceClass = computed(() => {
    if (currentPrice.value > previousPrice.value) return 'text-success';
    if (currentPrice.value < previousPrice.value) return 'text-danger';
    return ''; // No change
});

const fetchPrice = async () => {
    try {
        const response = await fetch(`/api/tokens/${props.mint}/price`);
        if (!response.ok) throw new Error('Failed to fetch price');
        const data = await response.json();
        previousPrice.value = currentPrice.value; // Store previous before updating
        currentPrice.value = data.price_usd || 0;
    } catch (error) {
        console.error(`Error fetching price for ${props.mint}:`, error);
        // Optionally stop polling on error
        // clearInterval(intervalId);
    }
};

onMounted(() => {
    fetchPrice(); // Initial fetch might be slightly delayed vs SSR, acceptable for now
    intervalId = setInterval(fetchPrice, 5000); // Poll every 5 seconds
});

onUnmounted(() => {
    clearInterval(intervalId);
});

// Optional: If using Inertia and navigating away, ensure interval is cleared
// watch(() => usePage().url.value, () => {
//   clearInterval(intervalId);
// });

</script>
